module.exports = __webpack_public_path__ + "media/audio32.a6af1978.mp3";